import { loop, Effects } from 'redux-loop';

import { init as meInit } from 'modules/me';
import { fetchSubject, fetchAlertSubject } from 'modules/subject';
import { fetchDownLimitTasks } from 'modules/elog';
import { actions } from 'modules/base';
import moment from 'moment';
const me = JSON.parse(localStorage.me);
const [ meModel, meEffect ] = meInit();

export default () => {
  return loop({
    me: me,
  },
    Effects.batch([
      meEffect,
      Effects.promise(fetchSubject, {id: 'navBarSubjectLabel', limit: 200, label: me.permission.layout.navBarSubjectLabel}),
      Effects.promise(fetchSubject, {id: 'sideBar1', limit: 200, label: me.permission.layout.sideBar[0]}),
      Effects.promise(fetchSubject, {id: 'sideBar2', limit: 200, label: me.permission.layout.sideBar[1]}),
      Effects.promise(fetchSubject, {id: 'sideBar3', limit: 200, label: me.permission.layout.sideBar[2]}),
      Effects.promise(fetchSubject, {id: 'panel_row3_left', limit: 200, label: me.permission.layout.panel_row3_left}),
      Effects.promise(fetchSubject, {id: 'panel_row1_left', ids: [me.permission.layout.panel_row1_left]}),
      Effects.promise(fetchSubject, {id: 'panel_row1_right', ids: [me.permission.layout.panel_row1_right]}),
      Effects.promise(fetchSubject, {id: 'panel_row2', ids: [me.permission.layout.panel_row2]}),
      Effects.promise(fetchSubject, {id: 'panel_row3_right', ids: [me.permission.layout.panel_row3_right]}),
      Effects.promise(fetchSubject, {ids: [me.permission.searchSubject || "56d94161a4308849680000ac"]}),
      Effects.promise(fetchDownLimitTasks, {startDate: moment().format('YYYY-MM-DD 00:00:00'), endDate:moment().format('YYYY-MM-DD 23:59:59'),limit:100, data: JSON.stringify({user: localStorage.register_email})}),
      Effects.constant(actions.inited()),
    ])
  );
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/app/init.js
 **/